import React from 'react';

import { Tag } from 'antd-v5';
import Text from 'scouting-ui/lib/Text';
import { cssVars } from 'scouting-ui/lib/variables';

import styles from './ScoutRankTag.module.scss';

interface ScoutRankTagProps {
  /** Rank name. Displays `N/A` if not provided */
  rank?: string;
}

export default function ScoutRankTag(props: ScoutRankTagProps) {
  const { rank = 'N/A' } = props;

  return (
    <Tag
      className={styles.scoutRankTag}
      bordered={false}
      color={cssVars['color-programs-SBSA-olive']}
    >
      <Text color="color-white" font="body-overline">
        {rank}
      </Text>
    </Tag>
  );
}
